const findValidOptionKey = (value, options) => {
  let result = null;
  for (const [key, val] of options) {
    if (val.label === value) {
      result = key;
    }
  }
  return result;
};

export { findValidOptionKey };
